import { BsPersonFill, BsUpload } from "react-icons/bs";
import { connect, useDispatch } from "react-redux";
import { userSignOut } from "../../../actions/Auth";
import classes from "./ProfileDropdown.module.scss";
import React from "react";
import { Link } from "react-router-dom";
import { setPageTitle } from "actions";
import { useTranslation } from "react-i18next";

function ProfileDropdown({ toggle, handleToggleDropdown }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const handleClickProfile = () => {
    handleToggleDropdown();
    dispatch(setPageTitle(t("header.profile")));
    clearSelectedMenu();
  };

  const clearSelectedMenu = () => {
    const menuLi = document.getElementsByClassName("menu");

    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].classList.remove("open", "active");
    }
  };

  return (
    <div
      className={toggle ? classes.toggleDropdown : classes.toggleDropdownNone}
    >
      <ul className={classes.ulDropdown}>
        <Link style={{ textDecoration: "none" }} to={"/app/profile-page"}>
          <li
            className={
              i18n.language === "en" ? classes.dropdownLtr : classes.dropdownRtl
            }
            onClick={handleClickProfile}
          >
            <span className={classes.listItem} style={{ color: "#1d1c22" }}>
              <p>{t("header.profile")}</p>
              <BsPersonFill style={{ fontSize: "20px", padding: 3 }} />
            </span>
          </li>
        </Link>

        <li
          onClick={() => {
            dispatch(userSignOut());
          }}
          className={
            i18n.language === "en" ? classes.dropdownLtr : classes.dropdownRtl
          }
        >
          <span className={classes.listItem} style={{ color: "#1d1c22" }}>
            <p>{t("header.exit")}</p>
            <BsUpload
              style={{
                fontSize: "20px",
                padding: 3,
                transform: `rotate(90deg)`,
              }}
            />
          </span>
        </li>
      </ul>
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return { locale };
};

export default connect(mapStateToProps, { userSignOut })(ProfileDropdown);
